/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { NullableOneOfPropertyOfStorageLocationOptions } from './NullableOneOfPropertyOfStorageLocationOptions';
import {
    NullableOneOfPropertyOfStorageLocationOptionsFromJSON,
    NullableOneOfPropertyOfStorageLocationOptionsFromJSONTyped,
    NullableOneOfPropertyOfStorageLocationOptionsToJSON,
} from './NullableOneOfPropertyOfStorageLocationOptions';

/**
 * 
 * @export
 * @interface NullableOneOfPropertyOfStorageLocation
 */
export interface NullableOneOfPropertyOfStorageLocation {
    /**
     * 
     * @type {string}
     * @memberof NullableOneOfPropertyOfStorageLocation
     */
    defaultValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NullableOneOfPropertyOfStorageLocation
     */
    value?: string | null;
    /**
     * 
     * @type {NullableOneOfPropertyOfStorageLocationOptions}
     * @memberof NullableOneOfPropertyOfStorageLocation
     */
    options?: NullableOneOfPropertyOfStorageLocationOptions | null;
    /**
     * 
     * @type {string}
     * @memberof NullableOneOfPropertyOfStorageLocation
     */
    $type?: NullableOneOfPropertyOfStorageLocationTypeEnum;
}


/**
 * @export
 */
export const NullableOneOfPropertyOfStorageLocationTypeEnum = {
    PtwDomainItemTypeCatalogInfrastructurePropertyTypesNullableOneOfProperty1PtwDomainItemTypeCatalogMedicalSystemsEnumsStorageLocationPtwDomainItemTypeCatalogMedicalSystemsPtwDomainItemTypeCatalogInfrastructure: 'Ptw.DomainItemTypeCatalog.Infrastructure.PropertyTypes.NullableOneOfProperty`1[[Ptw.DomainItemTypeCatalog.MedicalSystems.Enums.StorageLocation, Ptw.DomainItemTypeCatalog.MedicalSystems]], Ptw.DomainItemTypeCatalog.Infrastructure'
} as const;
export type NullableOneOfPropertyOfStorageLocationTypeEnum = typeof NullableOneOfPropertyOfStorageLocationTypeEnum[keyof typeof NullableOneOfPropertyOfStorageLocationTypeEnum];



/**
 * Check if a given object implements the NullableOneOfPropertyOfStorageLocation interface.
 */
export function instanceOfNullableOneOfPropertyOfStorageLocation(value?: unknown): value is NullableOneOfPropertyOfStorageLocation {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NullableOneOfPropertyOfStorageLocationTypeEnum)[0];
}

export function NullableOneOfPropertyOfStorageLocationFromJSON(json: any): NullableOneOfPropertyOfStorageLocation {
    return NullableOneOfPropertyOfStorageLocationFromJSONTyped(json, false);
}

export function NullableOneOfPropertyOfStorageLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): NullableOneOfPropertyOfStorageLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'defaultValue': json['defaultValue'] == null ? undefined : json['defaultValue'],
        'value': json['value'] == null ? undefined : json['value'],
        'options': json['options'] == null ? undefined : NullableOneOfPropertyOfStorageLocationOptionsFromJSON(json['options']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function NullableOneOfPropertyOfStorageLocationToJSON(value?: NullableOneOfPropertyOfStorageLocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'defaultValue': value['defaultValue'],
        'value': value['value'],
        'options': NullableOneOfPropertyOfStorageLocationOptionsToJSON(value['options']),
        '$type': value['$type'],
    });
}

